<template>

<div class="vx-card p-6">

  <vx-card card-border class="mb-4" title="Detalle del tipo de documento" title-color="dark" collapseAction>
    <div class="vx-row mb-2">
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span class="campoObligatorio">Tipo de documento *</span>
        </div>
        <div>
          <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombre" v-model="tipoDocumento.nombre" @input="v => { tipoDocumento.nombre = v.toUpperCase()}"/>
          <span class="text-danger text-sm"  v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div class="vx-col w-full mb-3">
          <span>Tipo de documento inactivo/activo</span>
        </div>
        <div class="vx-col w-full">
          <vs-switch vs-type="success" v-model="tipoDocumento.activo"/>
        </div>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span class="campoObligatorio">Categoría *</span>
        </div>
        <div>
          <v-select class="w-full" 
            v-model="tipoDocumento.categoria" 
            :options="filtrarTipoDocumento"
            placeholder="Seleccione categoría"
            label="categoria"
            :reduce="id => id.categoria"
          />
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full">
        <div v-if="tipoDocumento.categoria==='MANUAL'">
          <span class="campoObligatorio">Operador *</span>
        </div>
        <div v-if="tipoDocumento.categoria==='MANUAL'">
          <select-operador v-model="tipoDocumento.operador" />
        </div>
      </div>
    </div>
  </vx-card>

  <div class="vx-row">
    <div class="vx-col w-full flex justify-end">
      <vs-button class="mr-4 mb-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
      <vs-button color="warning" type="border" class="mb-2" @click="cancelar()">Cancelar</vs-button>
    </div>
  </div>
</div>

</template>

<script>
// Store Module
import valTiposDocumentosStore from '@/store/configuracion/val-tipos-documentos/index.js'
import vSelect from 'vue-select'
import selectOperador from '@/views/common-components/selectOperador'

export default {
  components: {
    vSelect,
    selectOperador
  },
  data () {
    return {
      valTiposDocumentos: [],
      tipoDocumento: {
        nombre: null,
        activo: false,
        categoria: null,
        operador: null
      }
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() 
        || this.tipoDocumento.nombre === null || this.tipoDocumento.nombre === undefined 
        || this.tipoDocumento.categoria === null || this.tipoDocumento.categoria === undefined
        || (this.tipoDocumento.categoria === 'MANUAL' && (this.tipoDocumento.operador === null || this.tipoDocumento.operador === undefined))
      ) {
        return false
      } else {
        return true
      }
    },
    filtrarTipoDocumento () {
      const filtrado = []
      this.valTiposDocumentos.forEach(function (item) {
        const i = filtrado.findIndex(x => x.categoria === item.categoria)
        if (i <= -1) {
          filtrado.push(item)
        }
      })                 
      return filtrado 
    }
  },
  methods:{
    cancelar () {
      this.$router.push({name:'valTiposDocumentos'})
    },
    guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      this.$store.dispatch('valTiposDocumentosStore/addTipoDocumento', this.tipoDocumento)
        .then((response)   => { 
          this.showUpdateSuccess(response.data.nombre)
          this.$router.push({ name: 'valTiposDocumentos' })
        })
        .catch((error) => {
          this.showUpdateError(error)
        })
    },
    showUpdateSuccess (tipoDocumento) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'TIPO DE DOCUMENTO CREADO',
        text: `El tipo de documento "${ tipoDocumento }" ha sido dado de alta correctamente.`
      })
    },
    showUpdateError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: `Error al dar de alta el tipo de documento: ${ error }`
      })
    }
  },
  async created () {
    if (!valTiposDocumentosStore.isRegistered) {
      this.$store.registerModule('valTiposDocumentosStore', valTiposDocumentosStore)
      valTiposDocumentosStore.isRegistered = true
    }

    await this.$store.dispatch('valTiposDocumentosStore/getTiposDocumentos')
      .then(() => {
        // Recorremos os tipo de documentos e se están activos engadímolas ao combo
        this.$store.state.valTiposDocumentosStore.tiposDocumentos.forEach(element => {
          if (element.activo) this.valTiposDocumentos.push(element)
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>